export default "__VITE_ASSET__CxZ$e8rK__"